module.exports = __webpack_public_path__ + "static/media/mikhael_marzuqa.82d3779f.jpg";